export default __webpack_public_path__ + "img/cIUQXkAQ.eeb7d218.svg";